import React from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import phoneIcon from '../assets/icons/phone_icon.svg';
import logo from '../assets/images/footer_logo.svg';
import { socialLinks } from '../utils/data/link/data';
import {
  footerMenu,
  footerPrivacyPolicy,
  footerQuickLinks,
  footerServices,
} from '../utils/data/footer/data';

function Footer() {
  const lang = Cookies.get('i18next') || 'en';
  const { t } = useTranslation();
  const { translations } = useSelector((state) => state.translation);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          {/* // <!-- Logo and Phone --> */}
          <div className="footer__brand">
            <NavLink to={`/${lang}`}>
              <img src={logo} alt="EcoSense" className="footer__logo" />
            </NavLink>
            <div className="footer__brand-line" />
            <a href="tel:8676" className="footer__phone">
              <img src={phoneIcon} alt="phone" />
              <p>8676</p>
            </a>
          </div>

          {/* // <!-- Quick Links --> */}
          <div className="footer__column">
            <h3 className="footer__title">{translations?.quick_links?.[lang]}</h3>
            <ul className="footer__list">
              {footerQuickLinks?.map((e) => (
                <li key={e.id} className="footer__item">
                  <NavLink to={`/${lang}${e.url[lang]}`} className="footer__link">{e.title[lang]}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* // <!-- Services --> */}
          <div className="footer__column">
            <h3 className="footer__title">{translations?.services?.[lang]}</h3>
            <ul className="footer__list">
              {footerServices?.map((e) => (
                <li key={e.id} className="footer__item">
                  <NavLink to={`/${lang}${e.url[lang]}`} className="footer__link">
                    {e.title[lang]}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* // <!-- About Us --> */}
          <div className="footer__column">
            <h3 className="footer__title">{translations?.home_about_us?.[lang]}</h3>
            <ul className="footer__list">
              {footerMenu?.map((e) => (
                <li key={e.id} className="footer__item">
                  <NavLink to={`/${lang}${e.url[lang]}`} className="footer__link">{e.title[lang]}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* // <!-- Social Media --> */}
          <div className="footer__social">
            <h3 className="footer__title">{translations?.follow_us?.[lang]}</h3>
            <div className="footer__social-links">
              {socialLinks.map((e) => (
                <a
                  target="_blank"
                  key={e.title}
                  href={e.href}
                  className="footer__social-link"
                  rel="noreferrer"
                >
                  <img src={e.icon} alt={e.title} className="footer__social-icon footer__social-icon" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="footer__bottom-line" />

        {/* // <!-- Bottom Bar --> */}
        <div className="footer__bottom">
          {footerPrivacyPolicy?.map((e) => (
            <NavLink key={e.id} to={`/${lang}${e.url[lang]}`} className="footer__privacy">{e.title[lang]}</NavLink>
          ))}
          <p className="footer__copyright">
            ©
            {' '}
            {new Date().getFullYear()}
            .
            {' '}
            {t('all_rights_reserved')}
            .
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
